import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClipboard,
  faGift,
  faTicketAlt,
  faCalendarAlt,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import { getCouponByApppliesId, VendorCoupons } from 'api/coupon/_requests';
import { useQuery } from '@tanstack/react-query';

interface Props {
  productId: string;
  couponApplied: string | null;
  setCouponApplied: (code: string) => void;
}

const CouponAndMore = ({
  couponApplied,
  setCouponApplied,
  productId
}: Props) => {
  const { data: couponsData = [], isFetching } = useQuery<VendorCoupons[]>({
    queryKey: ['all-coupons-Product', productId],
    queryFn: () => getCouponByApppliesId(productId)
  });

  const copyToClipboard = (code: string) => {
    navigator.clipboard.writeText(code);
    setCouponApplied(code);
  };

  return (
    <>
      <div className="border border-success-subtle rounded p-3 mb-3 bg-success-light bg-opacity-10 d-flex justify-content-between align-items-center">
        <div>
          <p className="fw-semibold mb-0">
            <FontAwesomeIcon icon={faGift} className="text-success me-2" />
            Sign Up &amp; Earn{' '}
            <span className="text-success">20 TreadSuoq Coins</span>
          </p>
          <small className="text-muted">
            &amp; save extra money on your next purchase.
          </small>
        </div>
        <FontAwesomeIcon icon={faChevronRight} className="text-muted fs-5" />
      </div>

      <div className="border border-success-subtle rounded p-3 bg-success-light bg-opacity-10">
        <h5 className="fw-semibold mb-3">Offers and Coupons</h5>

        {couponsData.map((offer, index) => (
          <div key={offer._id}>
            <div className="d-flex align-items-start mb-3">
              <div className="me-2 mt-1 fs-7 text-success-light">
                <FontAwesomeIcon icon={faTicketAlt} />
              </div>

              <div className="flex-grow-1">
                <p className="mb-1">
                  Get{' '}
                  {offer.discountType === 'percentage'
                    ? `${offer.value}%`
                    : `flat ₹${offer.value}`}{' '}
                  OFF
                </p>
                <small className="text-muted d-block">
                  {offer.appliesTo === 'all'
                    ? 'Applicable on all products'
                    : `Applies to: ${offer.appliesTo}`}
                </small>
                {offer.usageLimit > 0 && (
                  <small className="text-muted d-block">
                    {offer.usageLimit - offer.usedCount} uses left
                  </small>
                )}
                {offer.validTo && (
                  <small className="text-muted d-block">
                    Valid till {new Date(offer.validTo).toLocaleDateString()}
                  </small>
                )}
              </div>

              {offer.code ? (
                <div className="text-end">
                  <button
                    className={`btn btn-sm border-0 rounded-1 fw-semibold
                      ${
                        couponApplied === offer.code
                          ? 'bg-success text-white'
                          : 'bg-success text-white bg-opacity-75'
                      }`}
                    onClick={() => copyToClipboard(offer.code)}
                  >
                    {offer.code}
                  </button>
                  {couponApplied === offer.code && (
                    <small className="d-block text-muted">Coupon Copied</small>
                  )}
                </div>
              ) : null}
            </div>

            <hr />
          </div>
        ))}

        <div className="d-flex align-items-center mb-2">
          <div className="me-2 mt-1 fs-7 text-success-light">
            <FontAwesomeIcon icon={faClipboard} />
          </div>
          <div className="flex-grow-1">
            <p className="mb-1">
              Get GST invoice and save up to 18% on business purchases
            </p>
            <small className="text-muted d-block">
              Valid for registered businesses
            </small>
          </div>
        </div>

        <div className="d-flex align-items-center mb-2">
          <div className="me-2 mt-1 fs-7 text-success-light">
            <FontAwesomeIcon icon={faCalendarAlt} />
          </div>
          <div className="flex-grow-1">
            <p className="mb-1">
              EMIs Available On min. purchase of Rs. 3000 across banks
            </p>
            <small className="text-muted d-block">
              Interest rates may apply
            </small>
          </div>
        </div>
      </div>
    </>
  );
};

export default CouponAndMore;
